/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Schedule_Offset_DaysInputs */

const cs_automation_schedule_offset_days = /** @type {(inputs: Automation_Schedule_Offset_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odsazení (dny)`)
};

const en_automation_schedule_offset_days = /** @type {(inputs: Automation_Schedule_Offset_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset (days)`)
};

/**
* | output |
* | --- |
* | "Offset (days)" |
*
* @param {Automation_Schedule_Offset_DaysInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_schedule_offset_days = /** @type {((inputs?: Automation_Schedule_Offset_DaysInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Schedule_Offset_DaysInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_schedule_offset_days(inputs)
	return cs_automation_schedule_offset_days(inputs)
});